import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/a'
  },
  {
    name: 'jnh',
    component: () => import('./view/home/indexJnh.vue'),
    meta: {
      title: '宏祥五金制品厂'
    }
  },
  {
    name: 'a/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'p/:id',
    component: () => import('./view/home/indexPac.vue'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'b/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'c/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'd/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'e/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'f/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'g/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'h/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'i/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'j/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'k/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'l/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'm/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'n/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'o/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'p/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'q/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'r/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 's/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 't/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'u/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'v/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'w/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'x/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'y/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
  {
    name: 'z/:id',
    component: () => import('./view/home'),
    meta: {
      title: '力爽(临沂)阀门科技有限公司'
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
